/*
Copyright 2025 Adobe. All rights reserved.
This file is licensed to you under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License. You may obtain a copy
of the License at http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software distributed under
the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
OF ANY KIND, either express or implied. See the License for the specific language
governing permissions and limitations under the License.
*/

import { tag as html, TemplateResult } from '../custom-tag.js';

export { setCustomTemplateLiteralTag } from '../custom-tag.js';
export const TextItalicIcon = ({
  width = 24,
  height = 24,
  hidden = false,
  title = 'Text Italic',
} = {}): string | TemplateResult => {
  return html`<svg
    xmlns="http://www.w3.org/2000/svg"
    height="${height}"
    viewBox="0 0 36 36"
    width="${width}"
    aria-hidden=${hidden ? 'true' : 'false'}
    role="img"
    fill="currentColor"
    aria-label="${title}"
  >
    <path
      d="M7.919 4a1.561 1.561 0 0 0-1.351 1l-2.109 6a.685.685 0 0 0 .649 1h2a1.557 1.557 0 0 0 1.351-1l1.055-3h8l-7.028 20h-3a1.557 1.557 0 0 0-1.351 1l-.7 2a.685.685 0 0 0 .649 1h10a1.557 1.557 0 0 0 1.351-1l.7-2a.684.684 0 0 0-.649-1h-3l7.028-20h8l-1.055 3a.685.685 0 0 0 .649 1h2a1.557 1.557 0 0 0 1.351-1l2.109-6a.686.686 0 0 0-.649-1Z"
    />
  </svg>`;
};
